import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import '../variables.css';
import css from './checkbox.module.css';

const cx = classNames.bind(css);

function generateRandomId() {
  return 'a' + Math.random();
}

type Props = {
  id: string;
  disabled?: boolean;
  label: string;
  onChange?: (newValue: boolean, oldValue: boolean) => void;
  checked: boolean;
  fullWidth?: boolean;
} & React.HTMLProps<HTMLInputElement>;

/**
 * Primary UI component for user interaction
 */
export const Checkbox: React.FC<Props> = ({
  label,
  id,
  disabled,
  checked,
  onChange,
  fullWidth,
  ...restProps
}) => {
  const inputId = id || generateRandomId();
  return (
    <label className={cx('checkbox', { fullWidth })} htmlFor={inputId}>
      <input
        className={css.input}
        disabled={disabled}
        checked={!!checked}
        id={inputId}
        type="checkbox"
        onChange={() => onChange(!checked, !!checked)}
        {...restProps}
      />
      <i className={css.icon} />
      <span>{label}</span>
    </label>
  );
};

Checkbox.propTypes = {
  /**
   * Unique id to associate checkbox with
   */
  id: PropTypes.string,
  /**
   * Should the checkbox be in disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * Button contents
   */
  label: PropTypes.string.isRequired,
  /**
   * Handler function when checkbox state changes
   */
  onChange: PropTypes.func,
  /**
   * Whether to occupy the entire line or not
   */
  fullWidth: PropTypes.bool,
};

Checkbox.defaultProps = {
  disabled: false,
  fullWidth: false,
};
